import { useContext } from 'react';

import { BillingContext } from './BillingContext';

export const useBillingContext = () => {
  const context = useContext(BillingContext);
  if (!context) {
    throw new Error('useBillingContext must be used within a BillingProvider');
  }
  return context;
};
